import React from "react";
import CommonPageHeader from "../../../components/CommonPageHeader/CommonPageHeader";
import Footer from "../../../components/Shared/Footer";
import HomeHeader from "../../Home/Home/HomeHeader/HomeHeader";
import CellText from "./DoctorDetailsArea/CellText";
import { useParams } from "react-router-dom";
const cells = require("../../../utils/biosmedlast.json");

const Cell = () => {
  let { slug } = useParams();
  let datam = cells.filter((a) => a.seourl == slug);

  return (
    <>
      <HomeHeader />
      <CommonPageHeader title={datam[0].name} subtitle="Details" />
      <CellText data={datam} />
      <Footer />
    </>
  );
};

export default Cell;
